import React from 'react';

import CrudForm from '../../../Form/CrudForm';
import TitleWithDeleteButton from '../../../TitleWithDeleteButton';

import fields from './fields';

export default function BorrowerForm({
  createBorrower,
  borrower,
  onDelete,
  updateBorrower,
  isPending,
}) {
  const isEdit = !!borrower;
  return (
    <div className="mt-5">
      <TitleWithDeleteButton
        onDelete={onDelete}
        title={
          isEdit
            ? `${borrower.isCoborrower ? 'Coborrower' : 'Borrower'} ${borrower.firstName} ${borrower.lastName}`
            : 'Create new Borrower'
        }
      />
      <CrudForm
        fields={fields}
        createHandler={createBorrower}
        submitButtonLabel={borrower ? 'Update Borrower' : 'Create Borrower'}
        updateHandler={(formValues) =>
          updateBorrower({ formValues, borrowerId: borrower.id })
        }
        data={borrower}
        disabled={isPending}
      />
    </div>
  );
}
